import CategoryCard from "@/components/cards/CategoryCard";
import BreadCrumb from "@/components/global/buttons/BreadCrumb";
import Seo from "@/components/seo";
import { getCategoryTree } from "@/services/category";
import { fetchHandshake } from "@/services/handshake";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";

const Index = ({tree}) => {
  const { locale } = useRouter();
  console.log({tree})
  const title = locale === "en" ? "Categories" : "التصنيفات";
  return (
    <>
      <Seo title={title} />
      <BreadCrumb data={[title]} />
      <section className="w-11/12 mx-auto my-3 sm:my-5">
        <h1 className="mb-3 text-sm font-bold sm:mb-5 sm:text-base">
          {title}
        </h1>
        <div className='grid grid-cols-2 gap-3 min-[420px]:grid-cols-3 md:grid-cols-4 lg:grid-cols-5'>
          {tree?.children_data?.map((info, i) => (
            <CategoryCard key={i} itemData={info} fromCategories />
          ))}
        </div>
      </section>
    </>
  );
};

export default Index;

export async function getServerSideProps({ req, res, locale }) {
  const handshake = await fetchHandshake({ req, res, locale });
  const { data: tree } = await getCategoryTree(handshake);
  return {
    props: {
      tree: tree?.data || {},
      ...(await serverSideTranslations(locale, ["common", "category"])),
    },
  };
}
